import clsx from 'clsx';
import React, { useCallback } from 'react';

import { useAuth } from '../../../../auth';
import { useWeb3State } from '../../../../hooks';
import { MarketplaceToggle } from '../../../common/marketplaceToggler/MarketplaceToggler.component';
import { Spinner } from '../../../common/spinner/Spinner.component';
import {
  ConnectButton,
  Logo,
  Profile,
  Username,
  Visit,
  WalletInfo,
} from './blocks';
import styles from './styles.module.css';

interface Props {
  isOpen: boolean;
  profileImage?: string;
  setMobileOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const Header: React.FC<Props> = ({
  isOpen,
  setMobileOpen,
  profileImage,
}) => {
  const { walletDetails, isLoading } = useWeb3State();
  const { authenticated } = useAuth();

  const handleConnectModalOpen = useCallback(() => setMobileOpen(false), []);

  const showWalletInfo = Boolean(!isLoading && walletDetails.address);
  const showConnectButton = Boolean(!isLoading && !walletDetails.address);

  return (
    <>
      <Logo isAuth={authenticated} isOpen={isOpen} />
      <div className={clsx(styles.header, !isOpen && styles.headerSM)}>
        {authenticated && (
          <>
            <Profile isOpen={isOpen} image={profileImage} />
            <Username />
          </>
        )}
        {showWalletInfo && <WalletInfo isOpen={isOpen} />}
        {showConnectButton && (
          <ConnectButton
            isOpen={isOpen}
            onBeforeClick={handleConnectModalOpen}
          />
        )}
        {isLoading ? (
          <div className="my-2">
            <Spinner size={20} />
          </div>
        ) : (
          <MarketplaceToggle
            errorMsg="Disconnect, select the correct network in your wallet and try again."
            open={isOpen}
            className="mt-3"
            reload={false}
            sidebar
          />
        )}
        <Visit />
      </div>
    </>
  );
};
